import React from 'react';

interface Props {
  domId: string;
  title: string;
}

export const OverviewField = ({ title, domId, children }: React.PropsWithChildren<Props>) => {
  return (
    <div className="flex w-64 flex-col items-start">
      <label className="whitespace-nowrap body-1" htmlFor={domId}>
        {title}
      </label>
      <div className="w-full">{children}</div>
    </div>
  );
};
